<template>
  <AnalyticsWidget
    :title="title"
    :subTitle="subTitle"
    :gridWidth="gridWidth"
    :gridHeight="gridHeight"
    :embedded="embedded">

    <div class="row" v-if="listTitle">
      <div class="col-12">
        <ContentTitle>{{listTitle}}</ContentTitle>
      </div>
    </div>
    <div class="row no-gutter h-100">
      <div class="col-3" v-if="showList">
        <div>
          <slot name="filter" />
        </div>
        <Scroller :maxHeight="450">
          <StaticDataTable class="static-table-list" v-if="hasChartData" :smallRows="true">
            <template v-slot:header>
              <tr>
                <th width="60%">{{listNameTitle}}</th>
                <th width="40%">{{listValueTitle}}</th>
              </tr>
            </template>
            <template v-slot:body>
              <tr v-for="(dataItem, index) of dataList" :key="index">
                <td>{{dataItem.name}}</td>
                <td><span v-html="dataItem.displayValue" /></td>
              </tr>
            </template>
          </StaticDataTable>
        </Scroller>
      </div>
      <div :class="showList ? 'col-9' : 'col-12'" v-if="hasChartData">
        <ChartDoughnut
          :series="seriesData"
          :legend="chartLegend"
          :options="chartOptions"
        />
      </div>
    </div>
  </AnalyticsWidget>
</template>


<script>
import _ from 'lodash'
import AnalyticsWidget from '@/modules/intelligence/components/analyticsWidget'
import ChartDoughnut from '@/components/charts/chartDoughnut'

export default {
  name: 'AnalyticsListChartWidget',
  components: {
    AnalyticsWidget,
    ChartDoughnut
  },
  props: {
    title: String,
    subTitle: String,
    listTitle: String,
    gridWidth: Number,
    gridHeight: Number,
    embedded: Boolean,
    listNameTitle: {
      type: String,
      default: 'Item'
    },
    listValueTitle: {
      type: String,
      default: 'Value'
    },
    showLegend: {
      type: Boolean,
      default: true
    },
    showList: Boolean,
    dataList: Array,
    chartOptions: Object 
  },
  data() {
    return {
    }
  },
  computed: {
    hasChartData() {
      return this.dataList && this.dataList.length > 0
    },
    chartLegend() {
      return {
        data: (this.dataList || []).map(dataItem => dataItem.name),
        show: this.showLegend
      }
    },
    seriesData() {
      return [{
        name: this.listTitle,
        data: (this.dataList || []),
        label: {
          show: true,
          formatter(param) {
            return param.name
          }
        },
      }]
    }
  }
}
</script>